import React, {Component} from 'react';

class LineComponent extends Component {
    constructor(props){
        super(props)

    }

    render(){
        return(
            <div style = {{borderTop: this.props.Width || 1, borderTopColor:this.props.Color || 'green', borderTopStyle:'solid', marginTop: 10, marginBottom: 10, width:'100%'}}/>

        )
    }
}

export default LineComponent